export const ConnectorCommand = {
    'CREATE': 'create',
    'REPAIR': 'repair',
    'DROP': 'drop'
};
